import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  // Tu lógica de validación
  const isAuthenticated = localStorage.getItem('sessionID') !== null;

  if (isAuthenticated) {
    return true; // Permitir el acceso
  } else {
    // Si no está autenticado, redirige al inicio / login
    router.navigate(['auth/sign-in']); // <- Cambia '/login' por tu ruta real de inicio de sesión
    return false; // Bloquear el acceso
  }
};